import { Button } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  createNewDocument,
  getDocData,
  setDocData,
} from "../../Firebase/Firebase.utils";
import { useNavigate } from "react-router-dom";
import InputBox from "../../components/InputBox";
import { useState } from "react";
import ISBillingFormComponent from "./ISBillingFormComponent";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

function ContinueDraftISBilling() {
  const [formData, setFormData] = React.useState({});
  const [isProcessing, setIsProcessing] = React.useState(false);
  const currentUser = useSelector((state) => state.userObject);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    const getDoc = async () => {
      const doc = await getDocData("billing", id);
      setFormData(doc);
    };
    getDoc();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const billingDoc = {
      ...formData,
      comments: [],
      billing_type: "sale",
      created_at: new Date(),
      created_by: currentUser.email,
      status: "draft",
    };

    const submitBilling = async () => {
      try {
        const res = await setDocData("billing", id, billingDoc);
        setIsProcessing(false);

        navigate(`/bill-support/${id}`);
      } catch (error) {
        alert(error.message);
        setIsProcessing(false);
      }
    };
    submitBilling();
  };

  const handleSaveDraft = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const billingDoc = {
      ...formData,
      created_at: new Date(),
      created_by: currentUser.email,
      status: "draft",
    };

    const saveDraft = async () => {
      try {
        await setDocData("billing", id, billingDoc);
        setIsProcessing(false);

        navigate(`/dashboard`);
      } catch (error) {
        alert(error.message);
        setIsProcessing(false);
      }
    };
    saveDraft();
  };

  return (
    <div>
      <ISBillingFormComponent
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        handleSaveDraft={handleSaveDraft}
        isProcessing={isProcessing}
        formData={formData}
        disabled={false}
      />
    </div>
  );
}

export default ContinueDraftISBilling;
